'use strict';

exports.__esModule = true;

var _setStatic = require('./setStatic');

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/recompose/setDisplayName.js
 ** module id = 175
 ** module chunks = 1
 **/